import { IFinancialCockpitQbrDocument } from '../../api/types'

const toTime = (value: string): number => {
  const time = new Date(value).getTime()
  return Number.isNaN(time) ? 0 : time
}

export const sortQbrDocuments = (
  documents: IFinancialCockpitQbrDocument[]
): IFinancialCockpitQbrDocument[] =>
  [...documents].sort(
    (a, b) =>
      (b.FYear ?? -Infinity) - (a.FYear ?? -Infinity) ||
      (b.FQuarter ?? -Infinity) - (a.FQuarter ?? -Infinity) ||
      toTime(b.Modified) - toTime(a.Modified)
  )
